/**
 * request_id pass-through — every API call carries an X-Request-Id header
 * so client-originated actions correlate with Go access logs and the
 * envelope's `request_id` (backend/internal/httpapi RequestID reuses a
 * well-formed inbound id verbatim).
 *
 * Wire rules mirrored from the Go side (requestid.go validRequestID):
 * 1..64 chars of [A-Za-z0-9-_]; anything else is discarded server-side,
 * so the client validates before sending.
 */
/** Header carrying the request id in both directions (Go HeaderRequestID). */
export const REQUEST_ID_HEADER = 'X-Request-Id';
const REQUEST_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
/** Mirrors the Go inbound-id acceptance rule. */
export function isValidRequestId(id) {
    return REQUEST_ID_PATTERN.test(id);
}
/**
 * Generates a fresh request id. Prefers crypto.randomUUID (36 chars,
 * hyphens are in the accepted charset); falls back to 16 random bytes
 * hex-encoded, then to a time+random best-effort id for non-secure
 * contexts where crypto is unavailable.
 */
export function newRequestId() {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function') {
        return c.randomUUID();
    }
    if (c && typeof c.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        c.getRandomValues(bytes);
        let hex = '';
        for (const b of bytes) {
            hex += b.toString(16).padStart(2, '0');
        }
        return hex;
    }
    // Best-effort last resort (non-secure context, very old engine):
    // still matches the accepted charset, uniqueness is not guaranteed.
    return `fb-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
//# sourceMappingURL=request-id.js.map